import React from 'react';
import { Language, CompleteKundali } from '../types/kundali';
import { BtrDrawer } from './BtrDrawer';
import { UserProfile } from '../lib/firebase';
import { getBtrProfileInstanceKey } from '../utils/btrProfileIdentity';

interface BirthTimeRectificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  lang: Language;
  kundali?: CompleteKundali;
  onApplyRectifiedKundali?: (rectifiedKundali: CompleteKundali) => void;
  currentUser?: UserProfile | null;
}

export const BirthTimeRectificationModal: React.FC<BirthTimeRectificationModalProps> = ({
  isOpen,
  onClose,
  lang,
  kundali,
  onApplyRectifiedKundali,
  currentUser
}) => {
  return (
    <BtrDrawer
      key={getBtrProfileInstanceKey(kundali, currentUser?.uid)}
      isOpen={isOpen}
      onClose={onClose}
      kundali={kundali}
      currentUser={currentUser}
      onApplyRectifiedKundali={onApplyRectifiedKundali}
      lang={lang}
    />
  );
};

